import AccountCategoryListComponent from "../components/AccountCategoryList";
import useAccountCategoryList from "../hooks/useAccountCategory";

const AccountCategoryList = () => {
  const accountCategoryListProps = useAccountCategoryList();
  return <AccountCategoryListComponent {...accountCategoryListProps} />;
};

export default AccountCategoryList;
